<template>
  <div class="my-user-item-container">
    <div class="my-col">
      <div class="my-div">
        SN: <b>{{ item.sn }}</b>
      </div>
      <div class="my-div">
        <simple-item-ts-card :item="item"></simple-item-ts-card>
      </div>
      <div class="my-div">
        <b>{{ item.eventText }}</b>
      </div>
      <div class="my-grow"></div>
    </div>
  </div>
</template>

<script>
import SimpleItemTsCard from "../common/SimpleItemTSCard.vue";

export default {
  name: "cmd-card",
  components: { SimpleItemTsCard },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {},
  computed: {},
};
</script>

<style lang="css" scoped>
.my-user-item-container {
  margin-top: 15px;
  margin-bottom: 15px;
}

.my-col {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: solid 1px green;
  border-radius: 5px;
  justify-content: flex-start;
}

.my-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.my-div {
  margin-right: 20px;
}

.my-grow {
  flex-grow: 1;
}

.my-button {
  margin: 0px;
  padding: 0px;
  height: 24px;
}
</style>
